import React from 'react';
import { CaretRight } from '@phosphor-icons/react';

// Sticky screen header (handoff_app_design/README.md §4.7).
//
//   <Header title="תכנית אימונים" />                                     — plain screen title
//   <Header logo />                                                       — home: logo + "RitmoIQ"
//   <Header title="..." actions={[{ icon: <Bell/>, onClick, label: 'התראות' }]} />
//   <Header title="תכנית אימונים" subtitle="חצי מרתון · שבוע 4 מתוך 8"
//           onBack={...} actions={[{ icon: <ArrowsClockwise/>, text: 'עדכן', onClick }]} />
//
// Props:
//   subtitle — muted line under the title (omit for the plain/logo forms).
//   onBack   — renders a leading CaretRight button before the title/logo.
//   actions  — trailing buttons; each is icon-only unless it carries `text`, which renders a
//              labeled pill (e.g. a refresh action) instead of a bare icon square.
// No sign-out ever lives here — it's a Profile row only.
export default function Header({ title, subtitle, logo = false, onBack, actions = [], className = '' }) {
  return (
    <div
      className={`sticky top-0 z-10 flex items-center justify-between gap-3 px-5 pt-4 pb-3 ${className}`}
      style={{ top: 'env(safe-area-inset-top, 0px)', background: 'var(--bg)' }}
    >
      <div className="flex items-center gap-2.5 min-w-0 flex-1">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            aria-label="חזרה"
            className="w-10 h-10 rounded-control bg-surface border border-border flex items-center justify-center shrink-0 active:opacity-70"
          >
            <CaretRight size={18} weight="bold" className="text-text" />
          </button>
        )}
        {logo ? (
          <div className="flex items-center gap-2.5 min-w-0">
            <img src="/logo192.png" alt="RitmoIQ" className="w-[34px] h-[34px] rounded-[9px] object-cover block shrink-0" />
            <span className="font-extrabold text-[17px] text-text truncate" style={{ letterSpacing: '-.3px' }}>RitmoIQ</span>
          </div>
        ) : (
          <div className="min-w-0">
            <h1 className="block font-extrabold text-[28px] leading-tight text-text truncate">{title}</h1>
            {subtitle && <span className="block text-[14px] text-text-muted truncate mt-0.5">{subtitle}</span>}
          </div>
        )}
      </div>
      {actions.length > 0 && (
        <div className="flex items-center gap-2 shrink-0">
          {actions.map((a, i) => (
            <button
              key={i}
              type="button"
              onClick={a.onClick}
              aria-label={a.label || a.text}
              className={`rounded-control bg-surface border border-border active:opacity-70 flex items-center justify-center ${
                a.text ? 'h-10 px-3.5 gap-1.5' : 'w-10 h-10'
              }`}
            >
              <span className="text-text-muted text-[19px] flex items-center">{a.icon}</span>
              {a.text && <span className="font-bold text-sm text-text">{a.text}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
